import React from 'react'
import IconRow from './IconRow'

import materialsConfig from '../../configs/materials-config';

const MaterialsBody = ({ className }) => {
  return (
    <div className={`${className} materials-body`}>
      <IconRow config={materialsConfig}/>
    </div>
  );
}

export default MaterialsBody



// WEBPACK FOOTER //
// ./src/components/Home/MaterialsBody.js